import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import SocialMediaReportList from '../../../components/reports/SocialMedia/SocialMedia'
import InstagramReport from '../../../components/reports/SocialMedia/SelectedSocialMediaList/InstagramReport'
import YoutubeReport from '../../../components/reports/SocialMedia/SelectedSocialMediaList/YoutubeReport'

const TicketRoute = () => {
    return (
        <Routes>

            <Route
                path='/reports-list'
                element={
                    <SocialMediaReportList />
                }
            />
            <Route
                path='/instagram-report'
                element={
                    <InstagramReport />
                }
            />
            <Route
                path='/youtube-report'
                element={
                    <YoutubeReport />
                }
            />
            <Route index element={<Navigate to='/reports/report-social-media/reports-list' />} />

        </Routes >
    )
}

export default TicketRoute
